import * as React from 'react';
import { FC, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { Box, Checkbox, FormControlLabel, Grid, IconButton, Typography, useTheme } from '@mui/material';
import { contacts, instagram_qr } from '../../assets/backgrounds';
import LinkRouter from '../LinkRouter';
import { facebook, instagram, mail, telegram, tiktok } from '../../assets/icons';
import { Close } from '@mui/icons-material';
import { donate, fb, inst, tg, tt } from '../../assets/links';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface IProps {
    open: boolean;
    handleClose: () => void;
}

const DonateDialog: FC<IProps> = ({ open, handleClose }) => {
    const { palette } = useTheme();

    const [checked, setChecked] = useState<boolean>(false);

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            onClose={() => { handleClose(); setChecked(false) }}
            PaperProps={{
                sx: {
                    minWidth: "323px",
                    maxWidth: "323px",
                    height: "140px",
                    borderRadius: "4px",
                }
            }}
        >
            <DialogContent
                sx={{
                    background: `${palette.primary.dark}`,
                    p: "10px",
                    position: "relative"
                }}
            >
                <Box sx={{ display: "flex", alignItems: "start", pt: "40px" }}>
                    <Checkbox
                        onChange={(e: any, value: boolean) => { setChecked(value) }}
                        sx={{
                            width: "16px",
                            height: "16px",
                            color: "#fff",
                            '&:first-child': {
                                background: "#fff", borderRadius: "3px"
                            },
                            padding: 0,
                            mt: "4px", mr: "10px",

                        }}
                    />
                    <Typography variant="h5" fontSize="13px" lineHeight="20px" fontWeight="600" fontFamily="Fixel Display, sans-serif" sx={{ textTransform: "uppercase" }}>
                        Натискаючи галочку, я погоджуюсь з договором офертою
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button
                        sx={{
                            height: "24px",
                            paddingX: "12px",
                            mt: "13px",
                            fontSize: "12px", lineHeight: "22px",
                            "&:hover": {
                                background: palette.primary.main
                            },
                        }}
                        size="large"
                        variant="contained"
                        disableRipple
                        disabled={!checked}
                        onClick={() => {
                            window.open(donate)
                            setChecked(false)
                            handleClose();
                        }}
                    >
                        Далі
                    </Button>
                </Box>
                <IconButton disableRipple size="large" sx={{ position: "absolute", right: "10px", top: "10px", p: "0px" }} onClick={() => { handleClose(); setChecked(false) }}>
                    <Close fontSize="inherit" />
                </IconButton>
            </DialogContent>
        </Dialog >
    );
}


export default DonateDialog;
